export const ROUTES = {
  TEAM_PROJECTS: "/teams/:teamId",
  DESIGNS: "/projects/:projectId",
  DESIGNS_SHOW_NEW: "/projects/:projectId/newdesign",
  LOGIN_WITH_TOKEN: "/login/:token",
  LOGIN: "/login",
  SIGN_UP: "/signup",
  SIGN_UP_WITH_TOKEN: "/signup/:token",
  RESET_PASSWORD: "/resetpassword",
  UPDATE_PASSWORD: "/resetpassword/:token",
  HOME: "/home",
  REFER_A_FRIEND: "/referral",
  CART: "/cart",
  ORDERS: "/orders",
  ADMIN_PURCHASED_ORDERS: "/admin/orders",
  ADMIN_TECHPACK_ORDER: "/admin/techpack/order/:orderId",
  ADMIN_TECHPACK_PREORDER: "/admin/techpack/preorder/:preorderId",
  ADMIN_PREORDER: "/admin/preorder/:preorderId",
  ADMIN_VALIDATE_REFERRAL_CODE: "/admin/validate/referralcode",
  ORDERS_SESSION: "/orders/session/:sessionId", //From checkout success of Stripe
  ORDERS_PREORDERS: "/orders/request/:preorderId", //From preorder
  SIZES: "/projects/:projectId/collectsizes",
  COLLECT_SIZE: "/sizes/:token",
  COLLECT_SIZE_SUCCESS: "/sizes/success/:token",
  STUDIO: "/projects/:projectId/designs/:designId",
  STUDIO_PURCHASED_DESIGN:
    "/orders/:orderType/:orderId/designs/:designId/from/:historyFrom",
  JOIN: "/join/:token",
  SHIPPING_ADDRESS: "/cart/address",
  ERROR: "/error",
};

/**
 * Artworks types (aligned with Specs artwork types)
 */
export const ARTWORK_TYPES = Object.freeze({
  TECHPACK_PRODUCTION: "techpackproduction",
});

/**
 * Asset behaves like (aligned with Specs behavesLike)
 */
export enum BEHAVES_LIKE {
  DETAILED_PRINT_TYPE = "detailedPrintType",
  EMBROIDERY_PATCH_TYPE = "embroideryPatchType",
  LEATHER_TAG_TYPE = "leatherTagType",
  SCREENPRINT_TYPE = "screenprintType",
  WOVEN_TAG_TYPE = "wovenTagType",
}

export enum ONBOARDING_STEPS {
  EMAIL = "email",
  LOGIN = "login",
  SIGNUP = "signup",
  ABOUT_PROJECT = "about",
}

export enum ABOUT_PROJECT_STEPS {
  PROJEC_TYPE = "projectType",
  TEAM_NAME = "teamName",
  PROJECT_SIZE = "projectSize",
}

export enum PROJECT_SIZES {
  LESS_20 = "0-19",
  LESS_50 = "20-49",
  LESS_150 = "50-149",
  LESS_500 = "150-499",
  LESS_5000 = "500-4999",
  MORE_5000 = "5000-",
}

//About Project, for who
export enum PROJECT_TYPES {
  COMPANY = "company",
  STUDENT = "student",
  PERSONAL = "personal",
  OTHER = "other",
}
